import React, { useEffect, useState } from "react"
import "./style.scss"
import { FaSackDollar, FaBasketShopping, FaBook} from "react-icons/fa6";
import { FaUser } from "react-icons/fa";

import { PieChart, useDrawingArea } from '@mui/x-charts';
import { DateRangePicker } from 'rsuite';
import TickPlacementBars from "../barChart";
import { Formatter } from "utils/formatter";
import { Pagination, styled } from "@mui/material";
import { BsCashCoin } from "react-icons/bs";
import { PiBankFill } from "react-icons/pi";
import { MdQrCode2 } from "react-icons/md";
import { getBestSellerBook, getCountOrderStatus, getPaymentPercent, getTotalBooks, getTotalOrders, getTotalRevenue, getTotalUsers } from "services/admin/dashboardService";
import { PacmanLoader } from "react-spinners";
import { FormatCurrency } from "utils/formatCurrency";

const Dashboard = () => {
    const token = localStorage.getItem("token")
    const [isLoading, setIsLoading] = useState(false);
    const [countOrderStatus, setCountOrderStatus] = useState([]);
    const [paymentPercent, setPaymentPercent] = useState([]);
    const [bestSellerBooks, setBestSellerBooks] = useState()

    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1);

    const [totals, setTotals] = useState({
        revenue: 0,
        orders: 0, 
        books: 0, 
        users: 0,
    });

     // range date
    const [rangeDate, setRangeDate] = useState({countOrderStatus: { start: "", end: "" }});
    const formatToDate = (dateString) => {
        const date = new Date(dateString);
        // Đảm bảo rằng năm, tháng, ngày đều có định dạng 2 chữ số
        const formattedYear = date.getFullYear();
        const formattedMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // Tháng bắt đầu từ 0, nên cộng thêm 1
        const formattedDay = date.getDate().toString().padStart(2, '0'); // Đảm bảo ngày có 2 chữ số
        return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };


    const fetchTotalRevenue = async () => {
        const response = await getTotalRevenue(token)
        return response.data
    }

    const fetchTotalOrders = async () => {
        const response = await getTotalOrders(token)
        return response.data
    }

    const fetchTotalBooks = async () => {
        const response = await getTotalBooks(token)
        return response.data
    }

    const fetchTotalUsers = async () => {
        const response = await getTotalUsers(token)
        return response.data
    }

    useEffect(() => {
        const fetchTotals = async () => {
            setIsLoading(true)
            try {
                const [revenue, orders, books, users] = await Promise.all([
                    fetchTotalRevenue(),
                    fetchTotalOrders(),
                    fetchTotalBooks(),
                    fetchTotalUsers(),
                ]);
        
                setTotals({revenue, orders, books, users});
            } 
            catch (error) {
                console.log("fetchTotals:", error);
            }
            finally {
                setIsLoading(false)
            }
        }
        fetchTotals()
    }, [token])


    const orderStatusColors = {
        "Chờ xác nhận": "#FF6384",
        "Đã hủy": "red",
        "Đã giao": "#4BC0C0",
        "Đang vận chuyển": "#67e19d",
        "Đang đóng gói": "#9966FF",
        "Chờ thanh toán": "orange",
    };

    useEffect(() => {
        const fetchCountOrderStatus = async () => {
            // setIsLoading(true);
            try {
                const response = await getCountOrderStatus(token, rangeDate['countOrderStatus']);
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const transformedData = response.data
                        .filter(item => item.status !== "Tất cả") // bỏ tất cả
                        .map(item => ({
                            value: item.count,
                            label: item.status,
                            color: orderStatusColors[item.status] || "black",
                        }));
                    setCountOrderStatus(transformedData);
                } 
                else {
                    setCountOrderStatus([]);
                }
            } 
            catch (error) {
                console.log("fetchCountOrderStatus:", error);
                setCountOrderStatus([]);
            } 
            // finally {
            //     setIsLoading(false);
            // }
        };
    
        fetchCountOrderStatus();
    }, [token, rangeDate['countOrderStatus']]);
    
    useEffect(() => {
        const fetchPaymentPercent = async () => {
            setIsLoading(true);
            try {
                const response = await getPaymentPercent(token);
               setPaymentPercent(response.data)
            } 
            catch (error) {
                console.log("fetchPaymentPercent:", error);
            } 
            finally {
                setIsLoading(false);
            }
        };
    
        fetchPaymentPercent();
    }, [token]);
    
    useEffect(() => {
        const fetchBestSellerBook = async () => {
            setIsLoading(true);
            try {
                const response = await getBestSellerBook(token, page - 1);
                setBestSellerBooks(response.data.content)
                setTotalPage(response.data.page.totalPages);
            } 
            catch (error) {
                console.log("fetchBestSellerBook:", error);
            } 
            finally {
                setIsLoading(false);
            }
        };
    
        fetchBestSellerBook();
    }, [token, page]);

    const handleChangePage = (event, value) => {
        setPage(value);
    }

    const handleDateChange = (value, name) => {
        if (name === "countOrderStatus") setCountOrderStatus()
        setRangeDate((prev) => ({
          ...prev,
          [name]: {
            start: value ? formatToDate(value[0]) : '', 
            end: value ? formatToDate(value[1]) : ''
          }
        }));
    };
      
    const StyledText = styled('text')(({ theme }) => ({
        fill: theme.palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fontSize: 15,
    }));
    
    function PieCenterLabel({ label, value }) {
        const { width, height, left, top } = useDrawingArea();
        return (
            <StyledText x={left + width / 2} y={top + height / 3}>
                {/* Chữ "Total" */}
                <tspan x={left + width / 2} dy="0" fontWeight="bold">{label}</tspan>
                {/* Số giá trị xuống dòng dưới */}
                <tspan x={left + width / 2} dy="1.5em">{value}</tspan>
            </StyledText>
        );
    }
    return (
        <>
            <div className="dashboard">
                <div className="dashboardBoxWrapper d-flex mt-5">
                    <div className="dashboardBox col">
                        <div className="row w-100 m-0">
                            <div className="col-lg-4 d-flex align-items-center">
                                <div className="avatar-md rounded color1">
                                    <FaSackDollar/>
                                </div>
                            </div>
                            <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                                <p>Tổng doanh thu</p>
                                <h5 className="m-0" style={{fontFamily: 'segoe ui'}}>{FormatCurrency(totals.revenue)}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="dashboardBox col">
                        <div className="row w-100 m-0">
                            <div className="col-lg-4 d-flex align-items-center">
                                <div className="avatar-md rounded color2">
                                    <FaBasketShopping/>
                                </div>
                            </div>
                            <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                                <p>Tổng lượt bán</p>
                                <h5 style={{fontFamily: 'Segoe ui'}} className="m-0">{totals.orders}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="dashboardBox col">
                        <div className="row w-100 m-0">
                            <div className="col-lg-4 d-flex align-items-center">
                                <div className="avatar-md rounded color3">
                                    <FaBook />
                                </div>
                            </div>
                            <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                                <p>Tổng sản phẩm</p>
                                <h5 style={{fontFamily: 'Segoe ui'}} className="m-0">{totals.books}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="dashboardBox col">
                        <div className="row w-100 m-0">
                            <div className="col-lg-4 d-flex align-items-center">
                                <div className="avatar-md rounded color4">
                                    <FaUser/>
                                </div>
                            </div>
                            <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                                <p>Tổng khách hàng</p>
                                <h5 style={{fontFamily: 'Segoe ui'}} className="m-0">{totals.users}</h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card border-0 p-4 mt-5">
                    <h5 style={{marginBottom: "5px"}}>Top sách bán chạy</h5>
                    {bestSellerBooks && (
                        <>
                        {bestSellerBooks.map((book, index) => (
                            <div key={index}>
                                <hr style={{marginTop: '10px', marginBottom: '10px', borderTop: '1px solid rgba(0, 0, 0, 0.1) !important', opacity: '0.1'}}/>

                                <div className="row mb-1">
                                    <div className="col-lg-6 content">
                                        <div className="imgWrapper">
                                            <img src={book.book.imageLink} alt="" />
                                        </div>
                                        <div className="title-cate w-100">
                                            <h6>{book.book.title}</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <h6 className="text-danger mb-0" style={{fontWeight: '600'}}>{Formatter(book.book.discountedPrice)}</h6>
                                        <span className="w-100" style={{fontSize: '11px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.45', textAlign: 'end'}}>Giá tiền</span>
                                    </div>
                                    <div className="col-lg-1">
                                        <h6 className="mb-0">{book.book.soldQuantity}</h6>
                                        <span style={{fontSize: '11px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.45'}}>Đơn hàng</span>
                                    </div>
                                    <div className="col-lg-1">
                                        <h6 className="mb-0">{book.book.availableQuantity}</h6>
                                        <span style={{fontSize: '11px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.45'}}>Kho</span>
                                    </div>
                                    <div className="col-lg-2">
                                        {/* <h6 className="text-danger text-end fw-bold">{Formatter(1000000)}</h6>
                                        <span className="ms-auto text-end" style={{fontSize: '13px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.45'}}>Doanh thu</span> */}
                                        <h6 className="text-danger text-end fw-bold mb-0">{Formatter(book.revenue)}</h6>
                                        <div style={{fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '5px'}} className="text-end">Doanh thu</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </>
                    )}

                        <div className="d-flex tableFooter mt-1">
                        <Pagination 
                            className="ms-auto" 
                            count={totalPage} 
                            color="secondary"
                            page={page} 
                            onChange={handleChangePage}
                        />
                    </div>
                </div>
                <div className="mt-5 w-100 d-flex">
                    <DateRangePicker
                        placeholder="Chọn khoảng thời gian" 
                      onChange={(value) => handleDateChange(value, 'countOrderStatus')}
                    />
                </div>
                <div className="d-flex mt-3">
                    <div className="card border-0 p-4 me-4 col-lg-6 mb-5 d-flex justify-content-center align-items-center"  style={{ flex: 1 }}>
                        <h5 className="mb-5">Thống kê đơn hàng</h5>
                        {Array.isArray(countOrderStatus) && countOrderStatus.length > 0 ? (
                            <PieChart 
                                series= {[{ 
                                    data: countOrderStatus, 
                                    innerRadius: 90,
                                    outerRadius: 120,
                                    startAngle: -90,
                                    endAngle: 90,
                                    highlightScope: { fade: 'global', highlight: 'item' },
                                }]} 
                                margin={{ right: 5, top: 10}}
                                slotProps={{
                                    legend: {
                                        direction: 'row',
                                        position: { vertical: 'bottom', horizontal: 'middle' },
                                        padding: 0,
                                        markGap: 10,
                                        itemGap: 20,
                                        
                                    },
                                }}
                                width={500}
                                height={250}
                            >
                            <PieCenterLabel label="Tổng đơn hàng" value={countOrderStatus.reduce((sum, item) => sum + item.value, 0)} />
                            </PieChart>
                        ) : (
                            <div><PacmanLoader color="#5e2e86" /></div>
                        )}

                        
                    </div>


                    <div className="card border-0 p-4 col-lg-6 mb-5"  style={{ flex: 1 }}>
                        <h5 className="d-flex mb-5 justify-content-center">Phương thức thanh toán</h5>
                        <div className="payment-method d-flex">
                            <div className="col-6">
                                <p className="text-center mb-1">Thanh toán online</p>
                                {isLoading ? (
                                    <h4 className="text-center">0</h4>
                                ) : (
                                    <h4 className="text-center">
                                        {paymentPercent.find(item => item.method === "COD")?.count || 0}
                                    </h4>
                                )}
                            </div>
                            <div className="col-6">
                                <p className="text-center mb-1">Thanh toán tiền mặt</p>
                                {isLoading ? (
                                    <h4 className="text-center">0</h4>
                                ) : (
                                    <h4 className="text-center">
                                        {paymentPercent.find(item => item.method === "Internet Banking")?.count || 0}
                                    </h4>
                                )}
                            </div>
                        </div>

                        <div className="mt-4">
                            <div className="d-flex mt-3">
                                <div className="icon-payment color1"><BsCashCoin/></div>
                                <div className="ms-3 align-items-center d-flex" style={{fontWeight: '500'}}>Thanh toán tiền mặt</div>
                                <div className="progressBarBox ms-auto d-flex align-items-center" style={{ width: '20%' }}>
                                    <div className="progress" style={{ width: "100%" }}>
                                        <div
                                            className="progress-bar"
                                            style={{ width: "100%", background: "orange", fontWeight: '600' }}
                                        >
                                        {isLoading ? "0%" : `${paymentPercent.find(item => item.method === "COD")?.percent.toFixed(2) || 0}%`}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex mt-3">
                                <div className="icon-payment color2"><MdQrCode2/></div>
                                <div className="ms-3 align-items-center d-flex" style={{fontWeight: '500'}}>Thanh toán online</div>
                                <div className="progressBarBox ms-auto d-flex align-items-center" style={{ width: '20%' }}>
                                    <div className="progress" style={{ width: "100%" }}>
                                        <div
                                            className="progress-bar"
                                            style={{ width: "100%", background: "orange", fontWeight: '600' }}
                                        >
                                        {isLoading ? "0%" : `${paymentPercent.find(item => item.method === "Internet Banking")?.percent.toFixed(2) || 0}%`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
                {/* <div className="progressBarBox d-flex align-items-center">
                      <div className="progress" style={{ width: "10%" }}>
                        <div
                          className="progress-bar"
                          style={{ width: "100%", background: "blue" }}
                        >
                          100%
                        </div>
                      </div>
                    </div> */}
                {/* chart */}
                {/* <PieChart
                    margin={{ top: 0, bottom: 10, left: 10, right:10 }}
                    series={[
                        {
                            data: bookSalesData,
                            highlightScope: { fade: 'global', highlight: 'item' },
                            // faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                        },
                    ]}
                    slotProps={{
                        legend: {
                          direction: 'column',
                          position: { vertical: 'middle', horizontal: 'right' },
                          padding: 0,
                        },
                      }}
                    height={200}
                />

                <TickPlacementBars/> */}
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </>
    )
}

export default Dashboard;